export default "__VITE_ASSET__CzRYeMFt__"